import React from 'react';
import { Link } from 'react-router-dom';
import { useCurator } from '../../hooks/useCurator';
import { setViewAsClient } from '../../lib/adminView';

/**
 * A standing reminder that curation tools are on, and the way to turn them
 * off. Without it a curator can forget the "…" menus are theirs alone and
 * mistake them for something clients can see.
 */
const SuperAdminBar: React.FC = () => {
  const { isCurator, viewingAsClient } = useCurator();

  if (!isCurator && !viewingAsClient) return null;

  return (
    <div className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-2">
        <span className="px-2 py-0.5 rounded bg-[#E9B306] text-gray-900 text-[10px] font-bold tracking-[0.08em] uppercase">
          Super admin
        </span>

        <p className="text-[13px] text-white/80 flex-1 min-w-0">
          {viewingAsClient
            ? 'Viewing as a client. Curation tools are hidden.'
            : 'You see a ··· menu on every card. Clients never see it.'}
        </p>

        <button
          type="button"
          onClick={() => setViewAsClient(!viewingAsClient)}
          className="flex-shrink-0 px-3.5 py-1.5 rounded-lg border border-white/25 text-[13px] font-semibold hover:bg-white/10 transition-colors"
        >
          {viewingAsClient ? 'Back to admin view' : 'View as client'}
        </button>

        <Link
          to="/mgt-x7k9p2/dashboard"
          className="flex-shrink-0 text-[13px] font-semibold underline underline-offset-4 hover:opacity-80 transition-opacity"
        >
          Open admin panel →
        </Link>
      </div>
    </div>
  );
};

export default SuperAdminBar;
